import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import ProfileDropDown from "../../../../ProfileDropDown";
import DropDownOptions from "./DropDownOptions";
import { useDispatch, useSelector } from "react-redux";
import { GetEnrolledCourses } from "../../../../../../../Actions/CourseA";

const SignedUpRightSide = ({ setShowSidebar }) => {
    const Dispatch = useDispatch();
    const { Authenticated } = useSelector((Store) => Store.LoginSignupReducer);
    const { EnrolledCourses, loading } = useSelector((Store) => Store.CourseReducer);

    console.log("EnrolledCourses in SignedUpRightSide are:",EnrolledCourses)
    useEffect(() => {
        if (Authenticated)
            Dispatch(GetEnrolledCourses())
        }, [Dispatch, Authenticated])

    return (
        <>
          {EnrolledCourses?.length > 0 && (
            <Link
                to="/inbox"
                className="HeaderRightSide-LinkStyle SemiBold"
                onClick={() => setShowSidebar(false)}
            >
                <img
                    src={require("../Assets/Chat.svg").default}
                    alt=""
                    srcSet=""
                    className="w-[30x] h-[30px] lg:w-auto lg:h-auto"
                />
            </Link>
          )}
            <Link
                to="/Favourites"
                className="HeaderRightSide-LinkStyle SemiBold"
                onClick={() => setShowSidebar(false)}
            >
                <img
                    src={require("../Assets/NotificationIcon.svg").default}
                    alt=""
                    srcSet=""
                    className="w-[30x] h-[30px] lg:w-auto lg:h-auto"
                />
            </Link>
            {/* <Link
                to="/mycourses/Wishlist"
                className={`HeaderRightSide-LinkStyle SemiBold flex items-center gap-1`}
                onClick={() => setShowSidebar(false)}
            >
                <h4 className="fontStyle lg:hidden">WishList</h4>{" "}
                <img
                    src={require("../Assets/FavouriteIcon.svg").default}
                    alt=""
                    srcSet=""
                />
            </Link> */}
            {/* <Link
                to="/Favourites"
                className={`HeaderRightSide-LinkStyle SemiBold flex items-center gap-1`}
                onClick={() => setShowSidebar(false)}
            >
                <h4 className="fontStyle lg:hidden">My Cart </h4>
                <img
                    src={require("../Assets/CartIcon.svg").default}
                    alt=""
                    srcSet=""
                />
            </Link> */}
            <ProfileDropDown
                setShowSidebar={setShowSidebar}
                DropDownOptions={DropDownOptions}
            />
        </>
    );
};

export default SignedUpRightSide;
